import React from 'react';
import { Routes, Route, Navigate, useParams } from 'react-router-dom';
import ClientDashboard from '../components/ClientModule/ClientDashboard';
import ProfilePage from '../components/ClientModule/ProfilePage';
import PaymentPage from '../components/ClientModule/PaymentPage/PaymentPage';
import PaymentSucess from "../components/ClientModule/PaymentSuccess/PaymentSuccess"
import PaymentFailed from "../components/ClientModule/PaymentFailed/PaymentFailed"


const ClientRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="dashboard" replace />} />

      <Route path="dashboard" element={<ClientDashboard />} />
      <Route path="profile" element={<ClientDashboard />} />
      <Route path="add-candidate" element={<ClientDashboard />} />
   <Route path="finalreport/:candidateId" element={<ClientDashboard />} />

      <Route path="pending-submission" element={<ClientDashboard />} />
      <Route path="login-expired" element={<ClientDashboard />} />
      <Route path="case/ready" element={<ClientDashboard />} />
      <Route path="case/pending" element={<ClientDashboard />} />
      <Route path="case/submitted" element={<ClientDashboard />} />
      <Route path="case/in-progress" element={<ClientDashboard />} />
      <Route path="case/completed" element={<ClientDashboard />} />
      <Route path="case/total" element={<ClientDashboard />} />

<Route
  path="approve-deny-requests"
  element={<ClientDashboard />}
/>

      {/* <Route path='payment' element={<ClientDashboard/>} /> */}
      <Route
        path="payment"

        element={<ClientDashboard />}
     />
     <Route path="payment-success" element={<ClientDashboard />} />
      <Route path="payment-failed" element={<ClientDashboard />} />
      <Route path="client-wallet" element={<ClientDashboard />} />
      <Route path="transaction-history" element={<ClientDashboard />} />
      
  

    </Routes>
  );
};

export default ClientRoutes;
